import React, { Component } from "react";
import { connect } from "react-redux";

/* Imports from Material MUI */
import { withStyles } from "@material-ui/core/styles";
import { DataGrid } from "@mui/x-data-grid";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDateRangePicker from "@mui/lab/DesktopDateRangePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { Button } from "@mui/material";
import { faTable } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "@mui/material/Tooltip";

import axios from "axios";
import moment from "moment";

import {
  filterOptionsSelectedAction,
  filterDataAction,
  setHistoryQueryDataAction,
} from "../redux/actions";

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "left",
    //border: "1px solid red",
    margin: "1rem",
    width: "95%",
    height: "85vh",
    fontFamily: `CircularXXWeb,"Segoe UI","Segoe",Tahoma,Helvetica,Arial,sans-seri`,
  },
  tableRoot: {
    overFlow: "auto",
    maxHeight: "75vh",
    display: "flex",
    //height: "100%",
  },
  table: {
    flexGrow: 1,
  },
  tableHeader: {
    fontWeight: "bold",
    fontSize: "14px",
    borderright: "1px solid #fff",
    color: "white",
    backgroundColor: "#113A7D", //"#1451B5", //"#2980B9",
    headerAlign: "center",
  },
  dataGrid: {
    height: "100%",
    width: "100%",
  },
  cellValue: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

class History extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 10,
      page: 0,
      filterHistoryData: [],
      isLoading: false,
      value: [
        moment(Date.now()).subtract(29, "days").format("MM/DD/YYYY"),
        moment(Date.now()).format("MM/DD/YYYY"),
      ],
    };
  }

  componentDidMount() {
    //console.log("props", this.props.historyData);
    //this.setState({ value: this.props.historyData.dateRange });
    if (
      this.props.user.name.trim() === "" ||
      this.props.user.email.trim() === ""
    ) {
      this.props.history.push("/login");
    } else {
      this.fetchHistoryData();
    }
  }

  fetchHistoryData = (selectedDates = this.state.value) => {
    this.setState({ isLoading: true });
    const postObject = {
      email: this.props.user.email,
      startDate: moment(selectedDates[0]).format("MM/DD/YYYY HH:mm:ss"),
      endDate: moment(selectedDates[1]).format("MM/DD/YYYY HH:mm:ss"),
      client: true,
    };
    axios
      .post("/api/getFilterHistory", postObject)
      .then((result) => {
        console.log("Result", result.data);
        if (result.data) {
          const filterHistoryData = result.data.length > 0 ? result.data : [];
          this.props.setHistoryQueryDataAction({
            historyQueryData: filterHistoryData,
            dateRange: [
              moment(selectedDates[0]).format("MM/DD/YYYY"),
              moment(selectedDates[1]).format("MM/DD/YYYY"),
            ],
          });
          this.setState({ filterHistoryData, isLoading: false });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log("Error", err.message);
      });
  };

  handleDate = (selectedDates) => {
    this.setState({ value: selectedDates });
  };

  onQueryClick = (filter) => (e) => {
    this.setState({ isLoading: true });
    console.log("filter", filter);
    if (filter) {
      const selectedFilterPayload = {
        region: filter.region ? filter.region.split(",").map(Number) : null,
        state: filter.state ? filter.state.split(",") : null,
        make: filter.make ? filter.make.split(",") : null,
        model: filter.model ? filter.model.split(",") : null,
        style: filter.style ? filter.style.split(",") : null,
        condition: filter.condition ? filter.condition : null,
        fico: filter.fico_band ? filter.fico_band : null,
        income: filter.income_band ? filter.income_band : null,
        fico_level: filter.fico_level ? filter.fico_level : null,
        income_level: filter.income_level ? filter.income_level : null,
        sale_price_min: filter.sale_price_min ? filter.sale_price_min : null,
        sale_price_max: filter.sale_price_max ? filter.sale_price_max : null,
        apr_median: filter.apr_median ? filter.apr_median : null,
        yearOldest: filter.year ? filter.year : "",
        mileCap: filter.mileage ? filter.mileage : "",
        financedCap: filter.financed_cap ? filter.financed_cap : "",
        cashDown: filter.cash_down ? filter.cash_down : "",
        payCap: filter.pay_cap ? filter.pay_cap : "",
        tradeAmt: filter.trade_amt ? filter.trade_amt : "",
        paidOffAmt: filter.paid_off_amt ? filter.paid_off_amt : "",
        zipCode: filter.zip_code ? filter.zip_code : "",
        stateTax: filter.state_tax ? filter.state_tax : "",
        dmvFee: filter.dmv_fee ? filter.dmv_fee : "",
      };
      const payload = {
        query: filter.query,
        selectedFilters: selectedFilterPayload,
        client: true,
      };
      axios
        .post("/api/getDataFromHistoryQuery", payload)
        .then((result) => {
          console.log("Data from History Query", result.data);
          this.setState({ isLoading: false });
          if (result.data.data) {
            this.props.filterOptionsSelectedAction(selectedFilterPayload);
            this.props.filterDataAction({
              filterData: result.data.data,
              isLoading: false,
            });
            this.props.history.push("/");
          } else {
            console.log("No Data");
          }
        })
        .catch((err) => {
          console.log("Error", err.message);
        });
    }
  };

  handleSearch = () => {
    this.fetchHistoryData(this.state.value);
  };

  // followCursorTooltips = (value) => {
  //   return <Tooltip title={value} followCursor></Tooltip>;
  // };

  render() {
    const { classes } = this.props;
    const { filterHistoryData, isLoading, value } = this.state;
    const filterData = filterHistoryData;
    console.log("isLoading", isLoading);

    //DataGrid Columns Format and Column Names
    const currencyFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    });

    const NumberFormat = {
      type: "number",
      valueFormatter: ({ value }) =>
        new Intl.NumberFormat().format(Number(value)),
    };

    const usdPrice = {
      type: "number",
      valueFormatter: ({ value }) => currencyFormatter.format(Number(value)),
    };

    const headerColStyle = {
      headerClassName: classes.tableHeader,
      headerAlign: "center",
    };

    //Open Image attached to Vin Data
    const columns = [
      {
        field: "query",
        headerName: "Action",
        ...headerColStyle,
        width: 100,
        renderCell: (params) => (
          <strong
            onClick={this.onQueryClick(params.row)}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon
              size="lg"
              icon={faTable}
              style={{ color: "#1451B5", cursor: "pointer" }}
            />
            <Link
              style={{
                marginLeft: "0.25rem",
                fontSize: "14px",
                fontWeight: 500,
                textDecoration: "none",
                color: "#1451B5",
              }}
            >
              Click
            </Link>
          </strong>
        ),
      },
      {
        field: "inserted_date",
        headerName: "Inserted Date",
        ...headerColStyle,
        width: 200,
        type: "date",
        // valueFormatter: (params) => {
        //   // first converts to JS Date, then to locale option through date-fns
        //   return moment(params.value).format("MM/DD/YYY HH:mm:ss");
        // },
        // // valueGetter for filtering
        // valueGetter: (params) => {
        //   return moment(params.value).format("MM/DD/YYY HH:mm:ss");
        // },
        renderCell: (params) => {
          if (params.value && params.value.length > 50) {
            return (
              <Tooltip
                title={moment(params.value).format("MM/DD/YYYY HH:mm:ss")}
                followCursor
              >
                <div className="cellValue">
                  {moment(params.value).format("MM/DD/YYYY HH:mm:ss")}
                </div>
              </Tooltip>
            );
          } else {
            return (
              <div className="cellValue">
                {moment(params.value).format("MM/DD/YYYY HH:mm:ss")}
              </div>
            );
          }
        },
      },
      {
        field: "region",
        headerName: "Region",
        ...headerColStyle,
        width: 150,
      },
      {
        field: "state",
        headerName: "State",
        ...headerColStyle,
        width: 200,
        renderCell: (params) => {
          if (params.value && params.value.length > 20) {
            return (
              <Tooltip title={params.value} followCursor>
                <div className="cellValue">{params.value}</div>
              </Tooltip>
            );
          } else {
            return <div className="cellValue">{params.value}</div>;
          }
        },
      },
      {
        field: "make",
        headerName: "Make",
        ...headerColStyle,
        width: 300,
        renderCell: (params) => {
          if (params.value && params.value.length > 20) {
            return (
              <Tooltip title={params.value} followCursor>
                <div className="cellValue">{params.value}</div>
              </Tooltip>
            );
          } else {
            return <div className="cellValue">{params.value}</div>;
          }
        },
      },
      {
        field: "model",
        headerName: "Model",
        ...headerColStyle,
        width: 300,
        renderCell: (params) =>
          params.value && params.value.length > 20 ? (
            <Tooltip title={params.value} followCursor>
              <div className="cellValue">{params.value}</div>
            </Tooltip>
          ) : (
            <div className="cellValue">{params.value}</div>
          ),
      },
      {
        field: "style",
        headerName: "Style",
        ...headerColStyle,
        width: 300,
        renderCell: (params) =>
          params.value && params.value.length > 27 ? (
            <Tooltip title={params.value} followCursor>
              <div className="cellValue">{params.value}</div>
            </Tooltip>
          ) : (
            <div className="cellValue">{params.value}</div>
          ),
      },
      {
        field: "year",
        headerName: "Year",
        ...headerColStyle,
        width: 60,
      },
      {
        field: "mileage",
        headerName: "Mileage",
        ...headerColStyle,
        width: 150,
        ...NumberFormat,
      },
      {
        field: "condition",
        headerName: "Condition",
        ...headerColStyle,
        width: 150,
      },
      {
        field: "fico_band",
        headerName: "FICO Band",
        ...headerColStyle,
        width: 150,
      },
      {
        field: "income_band",
        headerName: "Income Band",
        ...headerColStyle,
        width: 150,
      },
      {
        field: "fico_level",
        headerName: "Fico Level",
        ...headerColStyle,
        width: 150,
        hide: true,
      },
      {
        field: "income_level",
        headerName: "Income Level",
        ...headerColStyle,
        width: 200,
        hide: true,
      },
      {
        field: "sale_price_max",
        headerName: "Sale Price Max",
        ...headerColStyle,
        width: 200,
        hide: true,
      },
      {
        field: "sale_price_min",
        headerName: "Sale Price Min",
        ...headerColStyle,
        width: 200,
        hide: true,
      },
      {
        field: "apr_median",
        headerName: "Apr Median",
        ...headerColStyle,
        width: 150,
        hide: true,
      },
      {
        field: "financed_cap",
        headerName: "Financed Cap",
        ...headerColStyle,
        width: 150,
        ...usdPrice,
      },
      {
        field: "pay_cap",
        headerName: "Payment Cap",
        ...headerColStyle,
        width: 150,
        ...usdPrice,
      },
      {
        field: "cash_down",
        headerName: "Cash Down",
        ...headerColStyle,
        width: 100,
        ...usdPrice,
      },
      {
        field: "trade_amt",
        headerName: "Trade Amt",
        ...headerColStyle,
        width: 100,
        ...usdPrice,
      },
      {
        field: "paid_off_amt",
        headerName: "Paid Off Amt",
        ...headerColStyle,
        width: 150,
        ...usdPrice,
      },
      {
        field: "zip_code",
        headerName: "Zip Code",
        ...headerColStyle,
        width: 100,
      },
      {
        field: "state_tax",
        headerName: "State Tax",
        ...headerColStyle,
        width: 100,
        ...NumberFormat,
      },
      {
        field: "dmv_fee",
        headerName: "DMV Fee",
        ...headerColStyle,
        width: 100,
        ...NumberFormat,
      },
      {
        field: "email",
        headerName: "Email",
        ...headerColStyle,
        width: 200,
        renderCell: (params) => {
          if (params.value && params.value.length > 100) {
            return (
              <Tooltip title={params.value} followCursor>
                <div className="cellValue">
                  {params.value
                    ? `${params.value.split("@")[0]}...`
                    : params.value}
                </div>
              </Tooltip>
            );
          } else {
            return <div className="cellValue">{params.value}</div>;
          }
        },
      },
      {
        field: "user_name",
        headerName: "User Name",
        ...headerColStyle,
        width: 150,
        renderCell: (params) => {
          if (params.value && params.value.length > 10) {
            return (
              <Tooltip title={params.value} followCursor>
                <div className="cellValue">{params.value}</div>
              </Tooltip>
            );
          } else {
            return <div className="cellValue">{params.value}</div>;
          }
        },
      },
    ];

    return (
      <div className={classes.root}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            fontSize: "22px",
            fontWeight: 700,
            marginBottom: "1rem",
          }}
        >
          {"History"}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginBottom: "1rem",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDateRangePicker
              startText="Start Date"
              value={value}
              onChange={(newValue) => {
                this.handleDate(newValue);
              }}
              renderInput={(startProps, endProps) => (
                <React.Fragment>
                  <TextField {...startProps} variant="standard" />
                  <Box sx={{ mx: 2 }}> to </Box>
                  <TextField {...endProps} variant="standard" />
                </React.Fragment>
              )}
            />
          </LocalizationProvider>
          <Button
            size="small"
            variant="contained"
            style={{ marginLeft: "1rem", background: "#1451B5" }}
            onClick={this.handleSearch}
          >
            Search
          </Button>
        </div>
        <div
          className={classes.tableRoot}
          style={{ height: "90vh", overflow: "none" }}
        >
          <div className={classes.table}>
            {/* Row height of 52 pixels.  */}
            <DataGrid
              style={{ fontSize: "12px",fontFamily: `CircularXXWeb,"Segoe UI","Segoe",Tahoma,Helvetica,Arial,sans-seri`, }}
              isCellEditable={false}
              disableExtendRowFullWidth={true}
              disableSelectionOnClick={true}
              getRowId={(row) => row.id}
              columns={columns}
              loading={isLoading}
              rows={filterData}
              rowHeight={45}
              showCellRightBorder
              showColumnRightBorder
              page={this.state.page}
              pageSize={this.state.pageSize}
              onPageSizeChange={(newPageSize) =>
                this.setState({ pageSize: newPageSize })
              }
              onPageChange={(newPage) => this.setState({ page: newPage })}
              rowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
              pagination
              className={classes.dataGrid}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mstp = (state) => {
  return {
    user: state.user,
    historyData: state.historyData,
    selectedMetaData: state.selectedMetaData,
    filterData: state.filterData,
  };
};

export default connect(mstp, {
  filterOptionsSelectedAction,
  filterDataAction,
  setHistoryQueryDataAction,
})(withStyles(styles, { withTheme: true })(History));
